import { Box, Typography, useTheme } from "@mui/material";
import { Property, HospitalityTypes, RentalTags } from "../../../types";
import { useEstimatedCost } from "../../../hooks/estimated-cost.hook";
import EditFinancialInfo from "./edit-financial-info";
import InfoCell from "../../../../common/components/ui-kit/info-cell";

export default function PropertyFinancialInfo({
  property,
}: {
  property: Property;
}) {
  const theme = useTheme();
  const { data, isLoading } = useEstimatedCost(
    {
      compoundId: property.compound?.id,
      propertyTypeId: property.propertyType?.id,
      unitArea: property.unitArea,
      landArea: property.landArea,
      numberOfBedrooms: property.numberOfBedrooms,
    },
    !!property.compound?.id && !!property.propertyType?.id,
  );

  return (
    <Box
      sx={{
        borderRadius: "12px",
        backgroundColor: "#FFFFFF",
        width: "100%",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              sx={theme.nawy.typography.english.variants.body.md.semibold}
            >
              Financial information
            </Typography>
            <EditFinancialInfo property={property} />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "40px",
              justifyContent: "start",
            }}
          >
            <InfoCell
              title={`Estimated finishing cost`}
              description={
                data?.range
                  ? `${data.currency} ${data.totalCost.toLocaleString()}`
                  : "No estimate available."
              }
              isLoading={isLoading}
            />

            <InfoCell
              title="Estimated rental yield"
              description={
                data?.range
                  ? `${data.currency} ${data.totalRent.toLocaleString()}`
                  : "No estimate available."
              }
              isLoading={isLoading}
            />

            <InfoCell
              title="Contract selling price"
              description={
                property.propertyFinishing?.contractSellingPrice
                  ? `EGP ${property.propertyFinishing?.contractSellingPrice.toLocaleString()}`
                  : "No price available."
              }
            />

            <InfoCell
              title="Actual selling price"
              description={
                property.propertyFinishing?.actualSellingPrice
                  ? `EGP ${property.propertyFinishing?.actualSellingPrice.toLocaleString()}`
                  : "No price available."
              }
            />
            <InfoCell
              title={`Rental Type`}
              description={
                property.propertyFinishing?.rentalTag
                  ? RentalTags[property.propertyFinishing?.rentalTag]
                  : "N/A"
              }
            />
            {property.propertyFinishing?.rentalTag === "hospitality" && (
              <InfoCell
                title="Hospitality Type"
                description={
                  property.hospitalityType
                    ? HospitalityTypes[property.hospitalityType]
                    : "N/A"
                }
              />
            )}

            <InfoCell
              title="Estimated Rental Price"
              description={
                property.propertyFinishing?.estimatedRentalPrice
                  ? `EGP ${property.propertyFinishing?.estimatedRentalPrice.toLocaleString()}`
                  : "No price available."
              }
            />
            <InfoCell
              title="Forcasted Rental Units"
              description={
                property.propertyFinishing?.forcastedRentalUnits
                  ? `${property.propertyFinishing?.forcastedRentalUnits}`
                  : "N/A"
              }
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
